import React, { Component, Fragment } from 'react'
import './style.css'

import axios from 'axios'
import swal from 'sweetalert'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Button, Glyphicon } from 'react-bootstrap'

import { getResourcePosts, getCurrentPost, setCurrentPost } from '../resource-posts/reducers/manageResourcePosts'

import ResourcePost from './components/ResourcePost'
import EditResourcePost from './components/EditResourcePost'

import AuthenticationComponent from '../../AuthenticationComponent';


class ResourcePostPageContainer extends Component {

  state = {
    post: "",
    editable: false,
    text: null,
    name: null,
    addedTags: []
  }

  componentDidMount() {
    this.props.getCurrentPost(this.props.match.params.post)
  }

  toggleEditable = () => {
    this.setState({ editable: !this.state.editable })
  }

  handleUpdatePost = (post) => {
    swal({
      text: "Editing the post... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false
    })
    axios({
      method: "PATCH",
      url: this.props.currentPost.url,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: post
    })
    .then(response => {
      swal({
        title: "Success!",
        text: "Resource post saved successfully",
        icon: "success",
        button: "Continue!",
      })
      this.setState({ editable: false })
      this.props.getCurrentPost(this.props.match.params.post)
    })
    .catch(error => {
        swal({
          title: "Error!",
          text: "There was an error in editing the post!",
          icon: "error",
          button: "Continue!",
        })
      })
  }

  handleDocumentClick = (documentUrl) => {
    let win = window.open(documentUrl, '_blank');
    win.focus()
  }

  render () {
    if (this.props.fetchingCurrentPost) {
      return (
        <Fragment>
          <br/><br/>
          <center>
            <div id="not-found">
              <img alt="loader" src={require("../../static/images/spinner.gif")} />
            </div>
          </center>
        </Fragment>
      )
    } else if (this.props.currentPost) {
      return (
        <div id="ResourcePostPageContainer">
          <AuthenticationComponent />
          {this.state.editable ?
            <EditResourcePost
              currentPost={this.props.currentPost}
              currentUser={this.props.currentUser}
              toggleEditable={this.toggleEditable}
              handleDocumentClick={this.handleDocumentClick}
              handleUpdatePost={this.handleUpdatePost}
            />
            :
            <ResourcePost
              currentPost={this.props.currentPost}
              currentUser={this.props.currentUser}
              toggleEditable={this.toggleEditable}
              handleDocumentClick={this.handleDocumentClick}
            />
          }
        </div>
      )
    } else {
      return (
        <div id="ResourcePostPageContainer">
          <div>
            <Link to="/resource-posts">
              <Button className="back-button">
                <Glyphicon glyph="arrow-left" /> Back
              </Button>
            </Link>
          </div>
          Couldn't find the post...
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    posts: state.manageResourcePosts.posts,
    currentPost: state.manageResourcePosts.currentPost,
    fetchingCurrentPost: state.manageResourcePosts.fetchingCurrentPost,
    currentUser: state.manageLogin.user,
    existingTags: state.manageResourcePosts.tags,
  }
}

export default connect(mapStateToProps, { getResourcePosts, getCurrentPost, setCurrentPost })(ResourcePostPageContainer);



// WEBPACK FOOTER //
// ./src/routes/resource-posts_post/ResourcePostPageContainer.js